<template>
    <icon-base v-bind="$props">
        <circle cx="12" cy="12" r="9" />
        <path d="M3 12h18" />
        <path d="M12 3c-3 3 -3 15 0 18c3 -3 3 -15 0 -18z" />
    </icon-base>
</template>

<script setup>
import IconBase, { iconProps } from './IconBase.vue'

defineProps(iconProps)
</script>
